import {fetch} from "utils/dataAccess";

export async function wmsSplitShipment(shipmentId) {
    const response = await fetch(`/shipments/wmsSplitShipment/${shipmentId}`)

    if (!response.ok) {
        throw new Error('Failed to split shipment');
    }

    return await response.json();
}